module.exports = __webpack_public_path__ + "media/images/map/marker-dot-02380e814c3e3341df85baa8180bc2f5.png";